import { ClockCircleOutlined, LogoutOutlined } from '@ant-design/icons';
import { css } from '@emotion/css';
import { Flex, Result, theme } from 'antd';

export const SignedOut = ({ expired }: { expired: boolean }) => {
  const { token } = theme.useToken();
  const Icon = expired ? ClockCircleOutlined : LogoutOutlined;

  return (
    <Flex justify="center">
      <Result
        className={css`
          max-width: 800px;
        `}
        icon={<Icon style={{ color: token.colorTextSecondary }} />}
        title={expired ? 'Sitzung abgelaufen' : 'Abgemeldet'}
        subTitle={
          expired
            ? 'Ihre Anmeldung bei labcomplete® ist abgelaufen. Öffnen Sie labcomplete® erneut über Ihr AIS.'
            : 'Sie wurden von labcomplete® abgemeldet. Öffnen Sie labcomplete® bei Bedarf erneut über Ihr AIS.'
        }
      />
    </Flex>
  );
};
